/* eslint-disable @typescript-eslint/no-explicit-any */
import R from 'app/assets/R'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { randomMoney } from 'app/components/tables/common-table/constant'
import { useDebounce, usePagination } from 'app/hook'
import { useGetVoucherFilterList } from 'app/react-query/hook/voucher'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { t } from 'i18next'
import {
  FONT_SIZE,
  FONT_WEIGHT,
  Pagination,
  initialPagination,
} from 'parkway-web-common'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

interface IProps {
  voucherCodes?: string[]
  onChangeVoucherCodes: (value: string[]) => void
}

export const SearchVoucher: React.FC<IProps> = ({
  voucherCodes,
  onChangeVoucherCodes,
}) => {
  const { flattenData } = usePagination()
  const [keywordSearchVoucher, setKeywordSearchVoucher] = useState<
    string | undefined
  >(undefined)

  const [loadMoreVoucher, setLoadMoreVoucher] = useState(0)
  const loadMoreVoucherDebounce = useDebounce(loadMoreVoucher, 200)
  const keywordSearchVoucherDebounce = useDebounce(
    keywordSearchVoucher,
    200,
  )

  const [pagination, setPagination] = useState<Pagination>({
    ...initialPagination,
    pageSize: 30,
  })

  const {
    data: voucherGroupApi,
    isLoading,
    hasNextPage: hasNextPageVoucher,
    fetchNextPage: fetchNextPageVoucher,
    isFetchingNextPage,
  } = useGetVoucherFilterList({
    keyword: keywordSearchVoucherDebounce,
    page: pagination.current,
    pageSize: pagination.pageSize,
    pagesize: pagination.pageSize,
  })

  const dataVoucherFlatten = useMemo(() => {
    return flattenData(voucherGroupApi)
  }, [voucherGroupApi])

  const dataVoucherGroup = useMemo(() => {
    return dataVoucherFlatten?.map(i => ({
      label: i?.code,
      value: i?.code,
    }))
  }, [voucherGroupApi])

  const onPopupVoucherScroll = e => {
    const heightChange =
      (e?.target?.scrollTop ?? 0) + (e?.target?.clientHeight ?? 0)
    const scrollHeight = e?.target?.scrollHeight ?? 0
    const isEndOfList = heightChange >= 0.7 * scrollHeight

    if (isEndOfList && hasNextPageVoucher) {
      setLoadMoreVoucher(randomMoney())
    }
  }

  const onChangeVoucher = (ids: string[]) => {
    onChangeVoucherCodes(ids as string[])
  }

  const onChangeVoucherSearch = (keyword: string) => {
    setKeywordSearchVoucher(keyword)
    setPagination({ ...pagination, current: 1 })
  }

  useEffect(() => {
    if (loadMoreVoucherDebounce) {
      fetchNextPageVoucher()
    }
  }, [loadMoreVoucherDebounce])

  return (
    <BaseSelectWrapper
      allowClear
      mode="multiple"
      value={voucherCodes}
      placeholder={t(R.strings.all)}
      onSearch={keyword => onChangeVoucherSearch(keyword)}
      options={dataVoucherGroup}
      loading={isLoading || isFetchingNextPage}
      onChange={ids => onChangeVoucher(ids as string[])}
      onPopupScroll={onPopupVoucherScroll}
      maxTagCount={1}
      filterSort={() => 0}
    />
  )
}

const BaseSelectWrapper = styled(BaseSelect)`
  width: 100%;
  min-width: 100px !important;

  .ant-select-selection-item {
    font-size: ${FONT_SIZE.xs};
    font-weight: ${FONT_WEIGHT.medium};
    color: ${convertedVariables.primaryColor};
    opacity: 0.9;
  }
`
